// extracted by mini-css-extract-plugin
module.exports = {"zoomWrapper":"EcgTransform_zoomWrapper__6Wlik","zoomContent":"EcgTransform_zoomContent__1WROi"};